import React from 'react';
import { X, Check } from 'lucide-react';
export function ComparisonBlock() {
  return <div className="my-16 bg-gray-50 border border-gray-200 rounded-xl p-8" data-id="element-47">
      <h3 className="text-xl font-bold text-center mb-8 text-gray-900" data-id="element-48">
        The Difference That Matters
      </h3>

      <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-49">
        {/* Knockoff */}
        <div className="bg-white rounded-lg p-6 border-2 border-red-200" data-id="element-50">
          <div className="bg-gray-100 rounded-lg p-6 mb-4 aspect-square flex items-center justify-center" data-id="element-51">
            <div className="text-center text-gray-400" data-id="element-52">
              <p className="text-sm font-medium mb-2" data-id="element-53">[Placeholder Image]</p>
              <p className="text-xs" data-id="element-54">$9 Amazon Knockoff</p>
            </div>
          </div>
          <div className="space-y-3" data-id="element-55">
            <div className="flex items-start gap-2" data-id="element-56">
              <X size={18} className="text-red-500 mt-0.5 flex-shrink-0" data-id="element-57" />
              <p className="text-sm text-gray-700" data-id="element-58">No airway resistance</p>
            </div>
            <div className="flex items-start gap-2" data-id="element-59">
              <X size={18} className="text-red-500 mt-0.5 flex-shrink-0" data-id="element-60" />
              <p className="text-sm text-gray-700" data-id="element-61">Breath doesn't slow down</p>
            </div>
            <div className="flex items-start gap-2" data-id="element-62">
              <X size={18} className="text-red-500 mt-0.5 flex-shrink-0" data-id="element-63" />
              <p className="text-sm text-gray-700" data-id="element-64">Cheap, light construction</p>
            </div>
          </div>
          <p className="mt-4 text-xs text-gray-500 italic" data-id="element-65">
            "A hollow object shaped like the thing"
          </p>
        </div>

        {/* Chime */}
        <div className="bg-white rounded-lg p-6 border-2 border-green-200" data-id="element-66">
          <div className="bg-gradient-to-br from-blue-50 to-gray-50 rounded-lg p-6 mb-4 aspect-square flex items-center justify-center" data-id="element-67">
            <div className="text-center text-gray-400" data-id="element-68">
              <p className="text-sm font-medium mb-2" data-id="element-69">[Placeholder Image]</p>
              <p className="text-xs" data-id="element-70">Chime ($40)</p>
            </div>
          </div>
          <div className="space-y-3" data-id="element-71">
            <div className="flex items-start gap-2" data-id="element-72">
              <Check size={18} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-73" />
              <p className="text-sm text-gray-700" data-id="element-74">
                Calibrated airway resistance
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-75">
              <Check size={18} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-76" />
              <p className="text-sm text-gray-700" data-id="element-77">Automatic 8-second exhale</p>
            </div>
            <div className="flex items-start gap-2" data-id="element-78">
              <Check size={18} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-79" />
              <p className="text-sm text-gray-700" data-id="element-80">
                Quality jewelry-grade build
              </p>
            </div>
          </div>
          <p className="mt-4 text-xs text-gray-500 italic" data-id="element-81">
            "The part that's actually engineered"
          </p>
        </div>
      </div>
    </div>;
}